import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectFormsViewTopBar } from "./TopBar"

export const projectFormsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectFormsViewTopBar,
}
